// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Posters / carousel section ===== */
.posters-section {
  max-width: 1400px; /* Increased from 1200px */
  margin: 0 auto;
  /* Small top padding so it sits close under the Flexible Learning Modes card */
  padding: 16px 24px 56px;
  text-align: center;
}

.posters-heading h2 {
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 700;
  color: #1e2a4a;
  margin: 0 0 40px; /* Increased from 8px to 40px for more space below heading */
}

.posters-heading p {
  color: #5b6478;
  margin: 0 0 32px;
  font-size: 1rem;
}

/* Shared carousel height on desktop (both panels match) */
:root {
  --carousel-desktop-height: min(70vh, 480px);
}

/* Container for two carousels side by side */
.poster-carousel-container {
  display: flex;
  gap: 32px; /* Increased from 24px for better spacing */
  justify-content: space-between;
  align-items: flex-start;
}

.poster-carousel-wrapper {
  flex: 1;
  min-width: 0; /* allows flex items to shrink below content size */
}

/* Mobile: Stack carousels vertically */
@media (max-width: 768px) {
  .poster-carousel-container {
    flex-direction: column;
    gap: 24px;
  }
  
  .poster-carousel-wrapper {
    width: 100%;
  }
}

/* Carousel layout: viewport with overlaid arrows */
.poster-carousel {
  position: relative; /* For absolute positioning of arrows */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%; /* Take full width */
}

/* No fixed box — the viewport takes the natural height of the poster image.
   Width is capped on desktop; height follows whatever the image's ratio is. */
.poster-viewport {
  width: 100%;
  max-width: 100%; /* Changed from 560px to allow side-by-side layout */
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 12px 32px rgba(30, 42, 74, 0.18);
}

/* Track width must match viewport so each slide is exactly one panel wide */
.poster-track {
  display: flex;
  width: 100%;
  transition: transform 0.45s ease;
}

.poster-slide {
  flex: 0 0 100%;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.poster-slide img {
  width: 100%;
  height: auto; /* image keeps its own aspect ratio — no crop, no bars */
  display: block;
  user-select: none;
}

/* Video slide (YouTube intro), shown as the last slide after the posters. */
.poster-slide--video {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  width: 100%;
  height: 100%;
}

/* Instagram slide styling */
.poster-slide--instagram {
  display: flex;
  align-items: stretch;
  justify-content: center;
  background: #fafafa;
  overflow: hidden;
  position: relative;
}

/* Instagram post card - vertical 4:5 ratio, balanced on desktop */
.instagram-post-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  background: #fff;
  position: relative;
  min-height: 0;
}

.poster-slide--instagram .instagram-post-card {
  min-height: 0;
}

/* Media area: full image/video visible, room for native controls */
.instagram-post-media {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  overflow: hidden;
}

/* Hover expansion for carousel post items - NO FLICKERING */
.carousel-post-item {
  position: relative;
  z-index: 1;
  overflow: visible;
}

.carousel-post-item img.instagram-post-image,
.carousel-post-item .carousel-video {
  width: 100%;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  object-fit: contain;
  object-position: center;
  display: block;
  background: transparent;
  transition: none;
  pointer-events: auto;
}

.carousel-video {
  background: #000;
  cursor: default;
  max-height: calc(100% - 4px);
}

.carousel-post-item video {
  pointer-events: auto !important;
}

/* Let the browser render native video controls — do not override webkit pseudo-elements */
.instagram-post-link {
  position: relative;
  flex-shrink: 0;
  margin: 12px auto 16px;
  padding: 10px 20px;
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  color: #fff;
  text-decoration: none;
  border-radius: 24px;
  font-size: 0.9rem;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  max-width: 90%; /* Prevent overflow on small screens */
  backdrop-filter: blur(8px); /* Better readability over images */
}

.instagram-post-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
  .instagram-post-link {
    padding: 9px 18px;
    font-size: 0.85rem;
    margin: 10px auto 14px;
    max-width: 85%;
  }
}

@media (max-width: 480px) {
  .instagram-post-link {
    padding: 8px 14px;
    font-size: 0.75rem;
    margin: 8px auto 12px;
    max-width: 80%;
  }

  .instagram-post-link svg {
    width: 12px;
    height: 12px;
    margin-right: 4px !important;
  }
}

/* Instagram fallback card - when no image available */
.instagram-fallback-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
}

.instagram-fallback-header {
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #efefef;
  background: #fafafa;
}

.instagram-fallback-header svg {
  color: #e4405f;
}

.instagram-fallback-header span {
  font-weight: 600;
  color: #262626;
  font-size: 0.95rem;
}

.instagram-fallback-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #fafafa 0%, #fff 100%);
}

.instagram-fallback-image-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #8e8e8e;
}

.instagram-fallback-image-placeholder svg {
  opacity: 0.3;
}

.instagram-fallback-image-placeholder p {
  margin: 0;
  font-size: 0.9rem;
  color: #8e8e8e;
}

.instagram-fallback-link {
  margin: 20px;
  padding: 14px 24px;
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  color: #fff;
  text-decoration: none;
  border-radius: 24px;
  font-size: 0.9rem;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  text-align: center;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.instagram-fallback-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

/* Responsive fallback button */
@media (max-width: 768px) {
  .instagram-fallback-link {
    margin: 16px;
    padding: 12px 20px;
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .instagram-fallback-link {
    margin: 12px;
    padding: 10px 16px;
    font-size: 0.8rem;
  }
}

/* Remove old embed styles - not needed anymore */
.instagram-embed-container {
  display: none;
}

.poster-video {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

.poster-video-shell {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: #000;
  contain: layout paint;
}

.poster-video-shell .poster-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  aspect-ratio: unset;
  min-height: unset;
}

.poster-swipe-edge {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 22%;
  z-index: 5;
  touch-action: none;
}

.poster-swipe-edge--left {
  left: 0;
}

.poster-swipe-edge--right {
  right: 0;
}

.poster-video-placeholder {
  width: 100%;
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
}

.poster-video-placeholder img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* YouTube carousel: natural 16:9 on phones/tablets */
@media (max-width: 768px) {
  .poster-carousel-wrapper--youtube .poster-viewport {
    height: auto;
  }
}

/* Prev / next arrows - positioned absolutely over the carousel */
.poster-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 40px; /* Smaller than before */
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(42, 26, 58, 0.85); /* Semi-transparent */
  color: #fff;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease, transform 0.2s ease;
  box-shadow: 0 4px 12px rgba(30, 42, 74, 0.35);
}

.poster-nav.prev {
  left: 8px; /* Position from left edge */
}

.poster-nav.next {
  right: 8px; /* Position from right edge */
}

.poster-nav:hover {
  background: rgba(74, 42, 90, 0.95);
  transform: translateY(-50%) scale(1.1);
}

.poster-nav.prev:hover {
  transform: translateY(-50%) scale(1.1);
}

.poster-nav.next:hover {
  transform: translateY(-50%) scale(1.1);
}

.poster-nav:active {
  transform: translateY(-50%) scale(0.95);
}

/* Dots */
.poster-dots {
  display: flex;
  justify-content: center;
  gap: 12px; /* Increased from 10px */
  margin-top: 20px; /* Reduced from 24px to bring dots closer to carousel */
}

.poster-dot {
  width: 12px; /* Increased from 10px */
  height: 12px; /* Increased from 10px */
  border-radius: 50%;
  border: none;
  padding: 0;
  background: #c9cdda;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}

.poster-dot.active {
  background: #2a1a3a;
  transform: scale(1.25);
}

/* Instagram Expanded Modal */
.instagram-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.instagram-modal-content {
  position: relative;
  max-width: 550px;
  max-height: 95vh;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.instagram-modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  backdrop-filter: blur(8px);
}

.instagram-modal-close:hover {
  background: rgba(0, 0, 0, 0.9);
  transform: scale(1.1);
}

.instagram-modal-media {
  width: 100%;
  height: auto;
  max-height: 85vh;
  object-fit: contain; /* Show full post without cropping */
  display: block;
  background: #000;
}

.instagram-modal-link {
  padding: 16px 24px;
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  color: #fff;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.instagram-modal-link:hover {
  background: linear-gradient(45deg, #e08323 0%, #d5582c 25%, #cc1733 50%, #bc1356 75%, #ac0878 100%);
}

/* Responsive modal */
@media (max-width: 768px) {
  .instagram-modal-content {
    max-width: 90vw;
  }
  
  .instagram-modal-media {
    max-height: 80vh;
  }
}

@media (max-width: 480px) {
  .instagram-modal-overlay {
    padding: 10px;
  }
  
  .instagram-modal-content {
    max-width: 95vw;
    border-radius: 12px;
  }
  
  .instagram-modal-close {
    width: 36px;
    height: 36px;
    font-size: 20px;
    top: 12px;
    right: 12px;
  }
  
  .instagram-modal-link {
    padding: 14px 20px;
    font-size: 0.85rem;
  }
}

/* ===== Desktop: side-by-side, matched balanced height ===== */
@media (min-width: 769px) {
  .poster-carousel-container {
    align-items: stretch;
  }

  .poster-carousel-wrapper {
    display: flex;
    flex-direction: column;
  }

  .poster-carousel {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  /* Both carousels share the same height box */
  .poster-carousel-wrapper--instagram .poster-viewport,
  .poster-carousel-wrapper--youtube .poster-viewport {
    flex: 1;
    width: 100%;
    height: var(--carousel-desktop-height);
    max-height: var(--carousel-desktop-height);
    aspect-ratio: unset;
  }

  .poster-carousel-wrapper--instagram .poster-track,
  .poster-carousel-wrapper--instagram .poster-slide,
  .poster-carousel-wrapper--instagram .instagram-post-card,
  .poster-carousel-wrapper--youtube .poster-track,
  .poster-carousel-wrapper--youtube .poster-slide,
  .poster-carousel-wrapper--youtube .poster-slide--video {
    height: 100%;
  }

  .poster-carousel-wrapper--youtube .poster-video-shell {
    width: 100%;
    height: 100%;
    aspect-ratio: unset;
    min-height: unset;
  }

  .poster-carousel-wrapper--youtube .poster-video-placeholder {
    width: 100%;
    height: 100%;
    aspect-ratio: unset;
    min-height: unset;
  }
}

/* ===== Phone / tablet: stacked, natural sizing (unchanged behaviour) ===== */
@media (max-width: 768px) {
  .poster-carousel-wrapper--instagram .poster-viewport {
    height: auto;
    max-height: none;
    aspect-ratio: unset;
  }

  .carousel-post-item img.instagram-post-image,
  .carousel-post-item .carousel-video {
    height: auto;
    max-height: none;
  }

  .instagram-post-card {
    height: auto;
  }
}

@media (max-width: 640px) {
  .posters-section {
    padding: 40px 16px;
  }

  .poster-carousel-container {
    flex-direction: column;
    gap: 32px;
  }

  .poster-nav {
    display: none;
  }

  .poster-viewport {
    max-width: 100%;
    border-radius: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/PosterCarousel/poster-carousel.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,iBAAiB,EAAE,0BAA0B;EAC7C,cAAc;EACd,8EAA8E;EAC9E,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,gBAAgB,EAAE,4DAA4D;AAChF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,2CAA2C;AAC7C;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,SAAS,EAAE,2CAA2C;EACtD,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,YAAY,EAAE,mDAAmD;AACnE;;AAEA,uCAAuC;AACvC;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,mDAAmD;AACnD;EACE,kBAAkB,EAAE,uCAAuC;EAC3D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,oBAAoB;AACnC;;AAEA;8EAC8E;AAC9E;EACE,WAAW;EACX,eAAe,EAAE,oDAAoD;EACrE,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,wDAAwD;EACtE,cAAc;EACd,iBAAiB;AACnB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,mEAAmE;AACnE;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,0FAA0F;AAC1F;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,mGAAmG;EACnG,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc,EAAE,sCAAsC;EACtD,0BAA0B,EAAE,mCAAmC;AACjE;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,4BAA4B;EAC9B;AACF;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mGAAmG;EACnG,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,+BAA+B;AAC/B;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA,iDAAiD;AACjD;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE;IACE,YAAY;EACd;AACF;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,WAAW,EAAE,wBAAwB;EACrC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC,EAAE,qBAAqB;EACzD,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,SAAS,EAAE,4BAA4B;AACzC;;AAEA;EACE,UAAU,EAAE,6BAA6B;AAC3C;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS,EAAE,wBAAwB;EACnC,gBAAgB,EAAE,uDAAuD;AAC3E;;AAEA;EACE,WAAW,EAAE,wBAAwB;EACrC,YAAY,EAAE,wBAAwB;EACtC,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB,EAAE,oCAAoC;EACzD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mGAAmG;EACnG,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mGAAmG;AACrG;;AAEA,qBAAqB;AACrB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA,+DAA+D;AAC/D;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,OAAO;IACP,aAAa;IACb,sBAAsB;EACxB;;EAEA,6CAA6C;EAC7C;;IAEE,OAAO;IACP,WAAW;IACX,sCAAsC;IACtC,0CAA0C;IAC1C,mBAAmB;EACrB;;EAEA;;;;;;IAME,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA,8EAA8E;AAC9E;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF","sourcesContent":["/* ===== Posters / carousel section ===== */\n.posters-section {\n  max-width: 1400px; /* Increased from 1200px */\n  margin: 0 auto;\n  /* Small top padding so it sits close under the Flexible Learning Modes card */\n  padding: 16px 24px 56px;\n  text-align: center;\n}\n\n.posters-heading h2 {\n  font-size: clamp(1.6rem, 3vw, 2.2rem);\n  font-weight: 700;\n  color: #1e2a4a;\n  margin: 0 0 40px; /* Increased from 8px to 40px for more space below heading */\n}\n\n.posters-heading p {\n  color: #5b6478;\n  margin: 0 0 32px;\n  font-size: 1rem;\n}\n\n/* Shared carousel height on desktop (both panels match) */\n:root {\n  --carousel-desktop-height: min(70vh, 480px);\n}\n\n/* Container for two carousels side by side */\n.poster-carousel-container {\n  display: flex;\n  gap: 32px; /* Increased from 24px for better spacing */\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.poster-carousel-wrapper {\n  flex: 1;\n  min-width: 0; /* allows flex items to shrink below content size */\n}\n\n/* Mobile: Stack carousels vertically */\n@media (max-width: 768px) {\n  .poster-carousel-container {\n    flex-direction: column;\n    gap: 24px;\n  }\n  \n  .poster-carousel-wrapper {\n    width: 100%;\n  }\n}\n\n/* Carousel layout: viewport with overlaid arrows */\n.poster-carousel {\n  position: relative; /* For absolute positioning of arrows */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%; /* Take full width */\n}\n\n/* No fixed box — the viewport takes the natural height of the poster image.\n   Width is capped on desktop; height follows whatever the image's ratio is. */\n.poster-viewport {\n  width: 100%;\n  max-width: 100%; /* Changed from 560px to allow side-by-side layout */\n  overflow: hidden;\n  border-radius: 16px;\n  box-shadow: 0 12px 32px rgba(30, 42, 74, 0.18);\n}\n\n/* Track width must match viewport so each slide is exactly one panel wide */\n.poster-track {\n  display: flex;\n  width: 100%;\n  transition: transform 0.45s ease;\n}\n\n.poster-slide {\n  flex: 0 0 100%;\n  width: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.poster-slide img {\n  width: 100%;\n  height: auto; /* image keeps its own aspect ratio — no crop, no bars */\n  display: block;\n  user-select: none;\n}\n\n/* Video slide (YouTube intro), shown as the last slide after the posters. */\n.poster-slide--video {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #000;\n  width: 100%;\n  height: 100%;\n}\n\n/* Instagram slide styling */\n.poster-slide--instagram {\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  background: #fafafa;\n  overflow: hidden;\n  position: relative;\n}\n\n/* Instagram post card - vertical 4:5 ratio, balanced on desktop */\n.instagram-post-card {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n  background: #fff;\n  position: relative;\n  min-height: 0;\n}\n\n.poster-slide--instagram .instagram-post-card {\n  min-height: 0;\n}\n\n/* Media area: full image/video visible, room for native controls */\n.instagram-post-media {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #000;\n  overflow: hidden;\n}\n\n/* Hover expansion for carousel post items - NO FLICKERING */\n.carousel-post-item {\n  position: relative;\n  z-index: 1;\n  overflow: visible;\n}\n\n.carousel-post-item img.instagram-post-image,\n.carousel-post-item .carousel-video {\n  width: 100%;\n  height: 100%;\n  max-height: 100%;\n  min-height: 0;\n  object-fit: contain;\n  object-position: center;\n  display: block;\n  background: transparent;\n  transition: none;\n  pointer-events: auto;\n}\n\n.carousel-video {\n  background: #000;\n  cursor: default;\n  max-height: calc(100% - 4px);\n}\n\n.carousel-post-item video {\n  pointer-events: auto !important;\n}\n\n/* Let the browser render native video controls — do not override webkit pseudo-elements */\n.instagram-post-link {\n  position: relative;\n  flex-shrink: 0;\n  margin: 12px auto 16px;\n  padding: 10px 20px;\n  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\n  color: #fff;\n  text-decoration: none;\n  border-radius: 24px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n  transition: all 0.3s ease;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  max-width: 90%; /* Prevent overflow on small screens */\n  backdrop-filter: blur(8px); /* Better readability over images */\n}\n\n.instagram-post-link:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);\n}\n\n@media (max-width: 768px) {\n  .instagram-post-link {\n    padding: 9px 18px;\n    font-size: 0.85rem;\n    margin: 10px auto 14px;\n    max-width: 85%;\n  }\n}\n\n@media (max-width: 480px) {\n  .instagram-post-link {\n    padding: 8px 14px;\n    font-size: 0.75rem;\n    margin: 8px auto 12px;\n    max-width: 80%;\n  }\n\n  .instagram-post-link svg {\n    width: 12px;\n    height: 12px;\n    margin-right: 4px !important;\n  }\n}\n\n/* Instagram fallback card - when no image available */\n.instagram-fallback-card {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.instagram-fallback-header {\n  padding: 16px 20px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-bottom: 1px solid #efefef;\n  background: #fafafa;\n}\n\n.instagram-fallback-header svg {\n  color: #e4405f;\n}\n\n.instagram-fallback-header span {\n  font-weight: 600;\n  color: #262626;\n  font-size: 0.95rem;\n}\n\n.instagram-fallback-body {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #fafafa 0%, #fff 100%);\n}\n\n.instagram-fallback-image-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  color: #8e8e8e;\n}\n\n.instagram-fallback-image-placeholder svg {\n  opacity: 0.3;\n}\n\n.instagram-fallback-image-placeholder p {\n  margin: 0;\n  font-size: 0.9rem;\n  color: #8e8e8e;\n}\n\n.instagram-fallback-link {\n  margin: 20px;\n  padding: 14px 24px;\n  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\n  color: #fff;\n  text-decoration: none;\n  border-radius: 24px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  transition: all 0.3s ease;\n  text-align: center;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.instagram-fallback-link:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);\n}\n\n/* Responsive fallback button */\n@media (max-width: 768px) {\n  .instagram-fallback-link {\n    margin: 16px;\n    padding: 12px 20px;\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .instagram-fallback-link {\n    margin: 12px;\n    padding: 10px 16px;\n    font-size: 0.8rem;\n  }\n}\n\n/* Remove old embed styles - not needed anymore */\n.instagram-embed-container {\n  display: none;\n}\n\n.poster-video {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  display: block;\n}\n\n.poster-video-shell {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n  background: #000;\n  contain: layout paint;\n}\n\n.poster-video-shell .poster-video {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  aspect-ratio: unset;\n  min-height: unset;\n}\n\n.poster-swipe-edge {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 22%;\n  z-index: 5;\n  touch-action: none;\n}\n\n.poster-swipe-edge--left {\n  left: 0;\n}\n\n.poster-swipe-edge--right {\n  right: 0;\n}\n\n.poster-video-placeholder {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n}\n\n.poster-video-placeholder img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* YouTube carousel: natural 16:9 on phones/tablets */\n@media (max-width: 768px) {\n  .poster-carousel-wrapper--youtube .poster-viewport {\n    height: auto;\n  }\n}\n\n/* Prev / next arrows - positioned absolutely over the carousel */\n.poster-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 10;\n  width: 40px; /* Smaller than before */\n  height: 40px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(42, 26, 58, 0.85); /* Semi-transparent */\n  color: #fff;\n  font-size: 1.5rem;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s ease, transform 0.2s ease;\n  box-shadow: 0 4px 12px rgba(30, 42, 74, 0.35);\n}\n\n.poster-nav.prev {\n  left: 8px; /* Position from left edge */\n}\n\n.poster-nav.next {\n  right: 8px; /* Position from right edge */\n}\n\n.poster-nav:hover {\n  background: rgba(74, 42, 90, 0.95);\n  transform: translateY(-50%) scale(1.1);\n}\n\n.poster-nav.prev:hover {\n  transform: translateY(-50%) scale(1.1);\n}\n\n.poster-nav.next:hover {\n  transform: translateY(-50%) scale(1.1);\n}\n\n.poster-nav:active {\n  transform: translateY(-50%) scale(0.95);\n}\n\n/* Dots */\n.poster-dots {\n  display: flex;\n  justify-content: center;\n  gap: 12px; /* Increased from 10px */\n  margin-top: 20px; /* Reduced from 24px to bring dots closer to carousel */\n}\n\n.poster-dot {\n  width: 12px; /* Increased from 10px */\n  height: 12px; /* Increased from 10px */\n  border-radius: 50%;\n  border: none;\n  padding: 0;\n  background: #c9cdda;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.2s ease;\n}\n\n.poster-dot.active {\n  background: #2a1a3a;\n  transform: scale(1.25);\n}\n\n/* Instagram Expanded Modal */\n.instagram-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.instagram-modal-content {\n  position: relative;\n  max-width: 550px;\n  max-height: 95vh;\n  background: #fff;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.6);\n  display: flex;\n  flex-direction: column;\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.instagram-modal-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(0, 0, 0, 0.7);\n  color: #fff;\n  font-size: 24px;\n  cursor: pointer;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  backdrop-filter: blur(8px);\n}\n\n.instagram-modal-close:hover {\n  background: rgba(0, 0, 0, 0.9);\n  transform: scale(1.1);\n}\n\n.instagram-modal-media {\n  width: 100%;\n  height: auto;\n  max-height: 85vh;\n  object-fit: contain; /* Show full post without cropping */\n  display: block;\n  background: #000;\n}\n\n.instagram-modal-link {\n  padding: 16px 24px;\n  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);\n  color: #fff;\n  text-decoration: none;\n  font-size: 0.95rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.instagram-modal-link:hover {\n  background: linear-gradient(45deg, #e08323 0%, #d5582c 25%, #cc1733 50%, #bc1356 75%, #ac0878 100%);\n}\n\n/* Responsive modal */\n@media (max-width: 768px) {\n  .instagram-modal-content {\n    max-width: 90vw;\n  }\n  \n  .instagram-modal-media {\n    max-height: 80vh;\n  }\n}\n\n@media (max-width: 480px) {\n  .instagram-modal-overlay {\n    padding: 10px;\n  }\n  \n  .instagram-modal-content {\n    max-width: 95vw;\n    border-radius: 12px;\n  }\n  \n  .instagram-modal-close {\n    width: 36px;\n    height: 36px;\n    font-size: 20px;\n    top: 12px;\n    right: 12px;\n  }\n  \n  .instagram-modal-link {\n    padding: 14px 20px;\n    font-size: 0.85rem;\n  }\n}\n\n/* ===== Desktop: side-by-side, matched balanced height ===== */\n@media (min-width: 769px) {\n  .poster-carousel-container {\n    align-items: stretch;\n  }\n\n  .poster-carousel-wrapper {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .poster-carousel {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n  }\n\n  /* Both carousels share the same height box */\n  .poster-carousel-wrapper--instagram .poster-viewport,\n  .poster-carousel-wrapper--youtube .poster-viewport {\n    flex: 1;\n    width: 100%;\n    height: var(--carousel-desktop-height);\n    max-height: var(--carousel-desktop-height);\n    aspect-ratio: unset;\n  }\n\n  .poster-carousel-wrapper--instagram .poster-track,\n  .poster-carousel-wrapper--instagram .poster-slide,\n  .poster-carousel-wrapper--instagram .instagram-post-card,\n  .poster-carousel-wrapper--youtube .poster-track,\n  .poster-carousel-wrapper--youtube .poster-slide,\n  .poster-carousel-wrapper--youtube .poster-slide--video {\n    height: 100%;\n  }\n\n  .poster-carousel-wrapper--youtube .poster-video-shell {\n    width: 100%;\n    height: 100%;\n    aspect-ratio: unset;\n    min-height: unset;\n  }\n\n  .poster-carousel-wrapper--youtube .poster-video-placeholder {\n    width: 100%;\n    height: 100%;\n    aspect-ratio: unset;\n    min-height: unset;\n  }\n}\n\n/* ===== Phone / tablet: stacked, natural sizing (unchanged behaviour) ===== */\n@media (max-width: 768px) {\n  .poster-carousel-wrapper--instagram .poster-viewport {\n    height: auto;\n    max-height: none;\n    aspect-ratio: unset;\n  }\n\n  .carousel-post-item img.instagram-post-image,\n  .carousel-post-item .carousel-video {\n    height: auto;\n    max-height: none;\n  }\n\n  .instagram-post-card {\n    height: auto;\n  }\n}\n\n@media (max-width: 640px) {\n  .posters-section {\n    padding: 40px 16px;\n  }\n\n  .poster-carousel-container {\n    flex-direction: column;\n    gap: 32px;\n  }\n\n  .poster-nav {\n    display: none;\n  }\n\n  .poster-viewport {\n    max-width: 100%;\n    border-radius: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
